<template>
  <div class='circle' id="wrapped">
    <span
      v-for="character in alphabet"
      :key="character"
      class='item'
      :class="questionClass(character)"
    >
      <span class="d-none d-md-block">{{ character }}</span>
    </span>
  </div>
</template>

<style scoped>
.circle {
  position: relative;
  width: 21.375em;
  height: 21.375em;
  border-radius: 50%;
  padding: 0;
  list-style: none;
  left: 50%;
  transform: translateX(-50%);
}

.circle > * {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.25em;
  height: 1.25em;
  margin: -0.625em;
}

.circle .item {
  display: block;
  width: 2.25em;
  height: 2.25em;
  transition: all .3s ease-in-out;
  border: 2px solid #fff;
  border-radius: 50%;
  background: var(--v-accent-base);
  /*background: var(--v-secondary-base);*/
  color: #fff;
  line-height: 2.25em;
  text-align: center;
  text-decoration: none;
  cursor: default;
  opacity: .2;
}
  .circle .item.current {
    background: var(--v-accent-base);
    opacity: 1;
  }
    .answer-success .circle .item.current {
      background: var(--v-success-base);
    }
    .answer-error .circle .item.current {
      background: var(--v-error-base);
    }

  .circle .item.invalid {
    background: lightgrey;
  }

/*  This code works well for 26 characters.
 *  Different number of characters? See this:
 *  https://gist.github.com/CodingCarlos/00891fff5733ad6e3ac578bd5ae722ec
 */
.circle > *:nth-of-type(1) {
  transform: rotate(270deg) translate(10.6875em) rotate(-270deg);
}
.circle > *:nth-of-type(2) {
  transform: rotate(283.845deg) translate(10.6875em) rotate(-283.845deg);
}
.circle > *:nth-of-type(3) {
  transform: rotate(297.69deg) translate(10.6875em) rotate(-297.69deg);
}
.circle > *:nth-of-type(4) {
  transform: rotate(311.535deg) translate(10.6875em) rotate(-311.535deg);
}
.circle > *:nth-of-type(5) {
  transform: rotate(325.38deg) translate(10.6875em) rotate(-325.38deg);
}
.circle > *:nth-of-type(6) {
  transform: rotate(339.225deg) translate(10.6875em) rotate(-339.225deg);
}
.circle > *:nth-of-type(7) {
  transform: rotate(353.07deg) translate(10.6875em) rotate(-353.07deg);
}
.circle > *:nth-of-type(8) {
  transform: rotate(366.915deg) translate(10.6875em) rotate(-366.915deg);
}
.circle > *:nth-of-type(9) {
  transform: rotate(380.76deg) translate(10.6875em) rotate(-380.76deg);
}
.circle > *:nth-of-type(10) {
  transform: rotate(394.605deg) translate(10.6875em) rotate(-394.605deg);
}
.circle > *:nth-of-type(11) {
  transform: rotate(408.450deg) translate(10.6875em) rotate(-408.450deg);
}
.circle > *:nth-of-type(12) {
  transform: rotate(422.295deg) translate(10.6875em) rotate(-422.295deg);
}
.circle > *:nth-of-type(13) {
  transform: rotate(436.14deg) translate(10.6875em) rotate(-436.14deg);
}
.circle > *:nth-of-type(14) {
  transform: rotate(449.985deg) translate(10.6875em) rotate(-449.985deg);
}
.circle > *:nth-of-type(15) {
  transform: rotate(463.830deg) translate(10.6875em) rotate(-463.830deg);
}
.circle > *:nth-of-type(16) {
  transform: rotate(477.675deg) translate(10.6875em) rotate(-477.675deg);
}
.circle > *:nth-of-type(17) {
  transform: rotate(491.52deg) translate(10.6875em) rotate(-491.52deg);
}
.circle > *:nth-of-type(18) {
  transform: rotate(505.365deg) translate(10.6875em) rotate(-505.365deg);
}
.circle > *:nth-of-type(19) {
  transform: rotate(519.21deg) translate(10.6875em) rotate(-519.21deg);
}
.circle > *:nth-of-type(20) {
  transform: rotate(533.055deg) translate(10.6875em) rotate(-533.055deg);
}
.circle > *:nth-of-type(21) {
  transform: rotate(546.900deg) translate(10.6875em) rotate(-546.900deg);
}
.circle > *:nth-of-type(22) {
  transform: rotate(560.745deg) translate(10.6875em) rotate(-560.745deg);
}
.circle > *:nth-of-type(23) {
  transform: rotate(574.59deg) translate(10.6875em) rotate(-574.59deg);
}
.circle > *:nth-of-type(24) {
  transform: rotate(588.435deg) translate(10.6875em) rotate(-588.435deg);
}
.circle > *:nth-of-type(25) {
  transform: rotate(602.28deg) translate(10.6875em) rotate(-602.28deg);
}
.circle > *:nth-of-type(26) {
  transform: rotate(616.125deg) translate(10.6875em) rotate(-616.125deg);
}
</style>

<script>
const CODE_A = 65;
const CODE_Z = 91;

function generateAbc() {
  const abc = [];
  for (let i = CODE_A; i < CODE_Z; i += 1) {
    abc.push(String.fromCharCode(i));
  }

  return abc;
}

export default {
  name: 'GameRondo',
  data: () => ({
    alphabet: generateAbc(),
  }),
  computed: {
    questions() {
      return this.$store.state.rondo.list[this.$i18n.locale];
    },
  },
  methods: {
    questionClass(char) {
      const question = this.questions[char.toLowerCase()];
      if (!question) {
        return 'invalid';
      }

      // Is already answered?
      if (question.answered && this.isClassMode) {
        return this.colorClass(question.team - 1);
      }

      if (question.answered) {
        return question.success ? 'success' : 'error';
      }

      // Is current question?
      const { current } = this.$store.state.rondo;
      if (!current) {
        return 'remaining';
      }

      if (current.toLowerCase() === char.toLowerCase()) {
        return 'current';
      }

      return 'remaining';
    },
  },
  // watch: {
  //   answer
  // },
};
</script>
